// @flow
import queryString from 'query-string';
import type {
  Maintenance,
  MaintenanceStatusesType,
  ExecutionBudgetGroupedList
} from './../types';
import { convertFromKopToRub } from '../helpers';
import { convertDataFromServer as convertDataFromServerGroupedList } from './executionBudget';

import {
  fetchRequest,
  initialFetchListParams,
  downloadRequestWithToken
} from './index';
import type { FetchListParams, ListResponse } from './index';

export const addMaintenance = async (
  maintenance: Maintenance
): Promise<Maintenance> => {
  const added = await fetchRequest.post('/maintenance', maintenance);
  if (added) return added;
  throw new Error('Не удалось создать ремонт');
};

export const updateMaintenance = async (
  maintenance: ?Maintenance
): Promise<Maintenance> => {
  const updated = await fetchRequest.put('/maintenance', maintenance);
  if (updated) return updated;
  throw new Error('Не удалось обновить ремонт');
};

export const fetchMaintenance = async (
  id: number,
  params: any = {}
): Promise<Maintenance> => await fetchRequest.get(`/maintenance/${id}`, params);

export const deleteMaintenance = async (id: number): Promise<Maintenance> => {
  const deleted = await fetchRequest.delete(`/maintenance/${id}`);
  if (deleted) return deleted;
  throw new Error('Не удалось удалить ремонт');
};

export const fetchMaintenances = async (
  params: FetchListParams<any> = initialFetchListParams
): Promise<ListResponse<Maintenance>> =>
  await fetchRequest.get('/maintenance', {
    ...initialFetchListParams,
    ...params
  });

export const printMaintenance = async (id: number) => {
  const print = await downloadRequestWithToken(`/maintenance/${id}/print`);
  if (print) return print;
  throw new Error('Не удалось загрузить файл');
};

export const print = async (params: any, filename?: string) => {
  const print = await downloadRequestWithToken(
    `/maintenance/print`,
    params,
    filename
  );
  if (print) return print;
  throw new Error('Не удалось загрузить файл');
};

export const changeStatusMaintenance = async (
  id: number,
  status: MaintenanceStatusesType
) => {
  const updated = await fetchRequest.post('/maintenance/changeStatus', {
    id,
    status
  });
  if (updated) return updated;
  throw new Error('Не удалось обновить статус');
};

export const getMaintenanceExpenseDirection = async (params: any) => {
  const expenseDirection = fetchRequest.get(
    '/maintenance/getExpenseDirection',
    params
  );
  if (expenseDirection) return expenseDirection;
  throw new Error('Не удалось найти направление расходов');
};

export const updateAct = async (
  params: any,
  data: any
): Promise<ListResponse<Maintenance>> => {
  const maintenance = await fetchRequest.put(
    `/maintenance/updateActId?${queryString.stringify(params)}`,
    data
  );
  if (maintenance) {
    return maintenance;
  }
  throw new Error('Не удалось закрепить акт за списоком замен гос. номеров');
};

export const getTotalSum = async (params: any = {}): Promise<number> => {
  const sum = await fetchRequest.get(`/maintenance/totalSum`, params);
  if (sum || sum === 0) return convertFromKopToRub(sum);
  throw new Error('Не удалось получить общую сумму');
};

export const groupedList = async (
  params: any = {}
): Promise<ListResponse<ExecutionBudgetGroupedList>> => {
  const groupedList = await fetchRequest.get(
    `/maintenance/groupedList`,
    params
  );
  if (groupedList)
    return {
      ...groupedList,
      data: groupedList.data.map(convertDataFromServerGroupedList)
    };
  throw new Error(
    'Не удалось получить сгруппированный список для исполнения бюджета'
  );
};

export const fillNextToDate = async (
  maintenance: Maintenance
): Promise<Maintenance> => {
  const updated = await fetchRequest.put(
    '/maintenance/nextToDate/fill',
    maintenance
  );
  if (updated) return updated;
  throw new Error('Не удалось проставить день следующего ТО');
};

export default {
  groupedList,
  print,
  getTotalSum,
  updateAct,
  getMaintenanceExpenseDirection,
  printMaintenance,
  addMaintenance,
  fetchMaintenance,
  updateMaintenance,
  deleteMaintenance,
  changeStatusMaintenance,
  fetchMaintenances,
  fillNextToDate
};
